// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'gic',
  heroImg: 'hero.jpg',
  heroTheme: 'dark',
  heroHeadingOne: 'GOOGLE.ORG IMPACT CHALLENGE',
  heroHeadingTwo: 'CONTEST PLATFORM',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle', 'Various'],
    },
    {
      title: 'BRAND',
      items: ['Google'],
    },
    {
      title: 'PLATFORM',
      items: ['Web'],
    },
  ],
  heading: `DESIGN, BUILD AND ONGOING SUPPORT FOR GOOGLE.ORG'S INTERNATIONAL CHARITY INITIATIVE`,
  challengeImg: 'challenge.png',
  challenge: ['To design and build a flexible and reusable web application for multi-phase competitions.'],
  solutionImg: 'solution.png',
  solution: ['After working with major creative agencies around the world to produce distinct Google.org Impact Challenge (GIC) sites for multiple country-specific iterations, Google asked us to redesign the platform to bring it in line with revised Google standards and to reduce the time and cost of deployment for new challenges.',
    'Each contest begins with Google asking charitable organisations to propose a project where technology investment will aid their work. The public then votes on a shortlist, and grants are awarded through a combination of popularity and the decision of the judges.',
    'Each contest has multiple phases, and the site changes automatically from launch through voting to the announcement of results, with associated management and analysis tools.'],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: 'SETTING STANDARDS',
      content: ['SITE DESIGN FOLLOWS GOOGLE STANDARDS.'],
    },
    {
      img: 'callout_2.jpg',
      title: 'PUBLIC DECIDES THE WINNING PROJECTS',
      content: ['OVER 6 MILLION VOTES RECEiVED.'],
    },
    {
      img: 'callout_3.jpg',
      title: 'FROM COUNTRY TO CITY',
      content: ['THE SUCCESS OF GIC LED TO A MOVE FROM COUNTRY-WIDE CHALLENGES TO CITY-SPECIFIC INITIATIVES.'],
    },
  ],
  nextCaseStudy: 'mercedes-4matic',
};

export default casestudyData;
